import { render, staticRenderFns } from "./EmsTokenIframeEmbed.vue?vue&type=template&id=1d5600e0&scoped=true"
import script from "./EmsTokenIframeEmbed.vue?vue&type=script&lang=js"
export * from "./EmsTokenIframeEmbed.vue?vue&type=script&lang=js"
import style0 from "./EmsTokenIframeEmbed.vue?vue&type=style&index=0&id=1d5600e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5600e0",
  null
  
)

export default component.exports